/* istanbul ignore file */
import React from 'react';
import AccountPageLayout from './AccountPageLayout';
import { RelatedContactsList } from 'domain/sales/contact';
import AccountRelatedContactsBreadcrumbs from 'domain/sales/account/Show/AccountRelatedContactsBreadcrumbs';

const AccountRelatedContacts = () => (
  <AccountPageLayout breadcrumbs={<AccountRelatedContactsBreadcrumbs />}>
    <RelatedContactsList />
  </AccountPageLayout>
);

export default AccountRelatedContacts;
